
import { ConfigProvider, Radio } from 'antd';
// import { PRIMARY_ORANGE_COLOR } from '../../utils/utils';
import { useMemo } from 'react';

const ORANGE_COLOR = '#ff6b38';

// data = [{ title: 'A', key: 1 }, { title: 'B', key: 2 }, ...];
// selectedValue = 1
const MyRadio = (props) => {
    const { data=[], onChange=()=>{}, classNameForEachRadio, classNameForGroup, ...rest } = props;
    
    const JsxData = useMemo(()=>{
      return data?.map(obj => 
        <Radio key={obj.key} value={obj.key}>
          <span className={`${classNameForEachRadio}`}>{obj.title}</span>
        </Radio>)}
    , [data]);

    const handleChange = (e) => {
        // console.log('radio checked', e.target.value);
        onChange(e.target.value);
    };

  return (
    <ConfigProvider
      theme={{
        components: {
          Radio: {
            buttonSolidCheckedActiveBg: ORANGE_COLOR,
            buttonSolidCheckedBg: ORANGE_COLOR,
          },
        },
        token: {
          colorPrimary: ORANGE_COLOR,
        },
      }}
    >
      <Radio.Group 
        onChange={handleChange}
        className={classNameForGroup}
        {...rest}
      >
        {/* <div className={classNameForGroup}> */}
          {JsxData}
        {/* </div> */}
      </Radio.Group>
    </ConfigProvider>
  )
}

export default MyRadio